import { EAffinyEventOrigin } from 'affiny-core/modules/api/core/affiny.eventorigins';
import { MessagesResource } from 'affiny-core/modules/api/core/resources/messages.resource';
import { ThreadsResource } from 'affiny-core/modules/api/core/resources/threads.resource';
import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import {
  selectLastMessageByThreadId,
  selectMemberByThreadId,
} from 'affiny-core/redux/selectors/threadsSelectors';
import { call, select } from 'redux-saga/effects';
import { threadsNormalizer } from './thread.normalizer';

export const PAGE_SIZE = 20;

export function* getThreads(pageNumber: number, pageSize: number = PAGE_SIZE) {
  const accountId = yield select(selectAccountId);
  const response = yield call(
    ThreadsResource.getThreadsByAccountId,
    accountId,
    pageNumber,
    pageSize
  );

  return threadsNormalizer(response);
}

/**
 * Send an empty message to see if the user will be able
 * to send a message in the given thread
 * AKA: "Dry run"
 */
export function* postDryRun(threadId: string) {
  const myAccountId = yield select(selectAccountId);
  const eventOrigin = EAffinyEventOrigin.W_BAL;
  const message = '';
  const otherMember = yield select(selectMemberByThreadId, threadId);

  return yield call(
    MessagesResource.postMessage,
    myAccountId,
    otherMember.id,
    true,
    message,
    eventOrigin
  );
}

export function* setThreadAsRead(threadId: string) {
  const myAccountId = yield select(selectAccountId);
  const lastMessage = yield select(selectLastMessageByThreadId, threadId);
  const otherMember = yield select(selectMemberByThreadId, threadId);

  const response = yield call(
    ThreadsResource.setThreadAsRead,
    myAccountId,
    otherMember.id,
    threadId,
    lastMessage.id
  );

  return response;
}
